import { Button } from 'react-bootstrap';
import { useDetailModals } from './detailModals';
import { shortId } from '../format';

// Renders an id / order-ref / visit-id / item / owner / delivery-person as a link that opens the
// right detail popup in place. `kind`: 'booking' | 'visit' | 'staff' | 'listing'.
//   <DetailLinkButton kind="booking" entity={row} />
//   <DetailLinkButton kind="staff" id={row.deliveryPersonId} label={row.deliveryPersonName} />
export default function DetailLinkButton({ kind, entity, id, vertical, label, className = '' }) {
  const modals = useDetailModals();

  const text = label
    || (entity && (entity.bookingRef ? `#${entity.bookingRef}` : shortId(entity._id || id)))
    || shortId(id)
    || '—';

  const open = () => {
    if (!modals) return;
    if (kind === 'booking') modals.openBooking(entity || { _id: id });
    else if (kind === 'visit') modals.openVisit(entity || { _id: id });
    else if (kind === 'staff') modals.openStaff(id || entity?._id);
    else if (kind === 'listing') modals.openListing(id || entity?._id, vertical);
  };

  const disabled = !modals
    || (kind === 'staff' && !(id || entity?._id))
    || (kind === 'listing' && !(id || entity?._id));

  if (disabled) return <span className={`font-monospace small ${className}`}>{text}</span>;

  return (
    <Button variant="link" size="sm" className={`p-0 align-baseline text-start ${className}`} onClick={open}>
      {text}
    </Button>
  );
}
